import { combineReducers } from "redux";
import { admin } from "./admin/reducer";
import { category } from "./category/reducer";
import { subcategory } from "./subcategory/reducer";
import { business } from "./business/reducer";
import { user } from "./user/reducer";
import { termsandcondition } from "./termsandcondition/reducer";
import { setting } from "./setting/reducer";
import { professional } from "./professional/reducer";
import { offer } from "./offer/reducer";
import { driver } from "./driver/reducer";
import { deliverySlice } from "../deliverySlice";
import { bookingSlice } from "./booking/bookingSlice";
import { reusableSlice } from "../reusableSlice";
import authReducer from "./auth/slice";

const reducers = combineReducers({
  user: user,
  termsandcondition: termsandcondition,
  setting: setting,
  professional: professional,
  offer: offer,
  driver: driver,
  category: category,
  subcategory: subcategory,
  admin: admin,
  business: business,
  deliverySlice: deliverySlice.reducer,
  bookingSlice: bookingSlice.reducer,
  reusableSlice: reusableSlice.reducer,
  auth: authReducer,
});

export default reducers;
